import { styled } from "@mui/material/styles";
import { TextField as MuiTextField } from "@mui/material";

const TextField = styled(MuiTextField)(({ styles }) => ({
  ".MuiInputBase-root": {
    backgroundColor: "var(--input-primary-bg)",
    color: "var(--input-primary-text)",
  },

  "& .MuiInputBase-input.Mui-disabled": {
    backgroundColor: "var(--input-disabled-bg)",
    WebkitTextFillColor: "var(--input-disabled-text)",
  },

  // "&:hover .MuiInputBase-root": {
  //   backgroundColor: "var(--input-primary-bg)",
  //   color: "var(--input-primary-text)",
  // },

  ...styles,
}));
export default TextField;
